import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  MenuItem,
  Typography,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputSelectSearch from "../../../components/InputSelectSearch";
import PropertyService from "../../../Services/PropertyService";
import propertyStore from "../../../Store/PropertyStore";
import roleStore from "../../../Store/RoleStore";
import usersStore from "../../../Store/UsersStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

const user = JSON.parse(localStorage.getItem("user"));
function Form(props) {
  const { classes, width, data, cancel } = props;
  let user = JSON.parse(localStorage.getItem("user"));
  const [loading, setLoading] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);
  const [roleState, roleActions] = roleStore();
  const [propertyState, propertyActions] = propertyStore();
  const [, usersActions] = usersStore();
  const [optionsProperty, setOptionsProperty] = React.useState([]);
  const [listProperty, setListProperty] = React.useState([]);
  const [selectedRole, setSelectedRole] = React.useState("");

  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      birthdate: new Date(),
      gender: "",
      phone: "",
      address: "",
      roles: "",
      email: "",
      password: "",
      repeatPassword: "",
      type: "staff",
      tenant: "",
      operational: "",
    },
  });
  const [componentWillMount] = React.useState(false);

  const asyncGetOptionsProperty = (query) => {
    return new Promise((resolve, reject) => {
      PropertyService.getList({
        num: 50,
        keyword: query,
        level:
          selectedRole?.type === "brand"
            ? 2
            : selectedRole?.type === "mall" ||
              selectedRole?.type === "hotel" ||
              selectedRole?.type === "residential"
            ? 1
            : "",
        type: selectedRole?.type,
        cursor: "",
        parent_id: user?.operational?.level === 2 ? user?.operational?.id : "",
      })
        .then((response) => {
          setListProperty(response.data);
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsProperty(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadFormDataRelation = (data, propertyOnly) => {
    setLoading(true);
    var query = {
      num: "50",
      cursor: "",
      position: "",
      search: "",
      type: "staff",
    };

    const propertyName = data ? data?.operational?.name : "";

    if (!propertyOnly) {
      return Promise.all([roleActions.get(query)]);
    } else {
      return Promise.all([asyncGetOptionsProperty(propertyName)]);
    }
  };

  React.useEffect(() => {
    if (
      (user?.type === "staff" &&
        user?.operational?.level === 2 &&
        state.formData.roles !== 2) ||
      (user?.type === "staff" &&
        user?.operational?.level === 3 &&
        state.formData.roles !== 1)
    ) {
      loadFormDataRelation(data, true).then(() => {
        setLoading(false);
      });
    }
  }, [selectedRole]);

  React.useEffect(() => {
    loadFormDataRelation(data, false).then(() => {
      setLoading(false);
    });

    if (data) {
      setState({
        formData: {
          id: data.id,
          name: data.name,
          birthdate: data.birthdate,
          gender: data.gender,
          phone: data.phone,
          address: data.address,
          roles: data.role.id,
          email: data.email,
          type: "staff",
          tenant: data.tenant?.id,
          operational:
            data.operational?.level !== 3 ? data.operational?.id : "",
        },
      });
    }
  }, [componentWillMount, data]);

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== state.formData.password) {
      return false;
    }
    return true;
  });

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleChangeRole = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    const roles = roleState?.data?.filter(
      (row) => row.id === event.target.value
    );
    if (roles.length > 0) {
      setSelectedRole(roles[0]);
    }
    setState({ formData });
  };

  const handleDateChange = (date) => {
    const { formData } = state;
    formData["birthdate"] = date;
    setState({ formData });
  };

  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
      if (props.data === null) {
        const { formData } = state;
        const objectUser = {
          roles: roleState.data,
          property: listProperty,
        };
        // console.log(formData);
        // console.log(objectUser);
        // console.log("++++++++++++++++++");
        await usersActions.store(formData, objectUser);
        handleCloseDialog();
        cancel();
      } else {
        const { formData } = state;
        const objectUser = {
          roles: roleState.data,
          property: listProperty,
        };
        await usersActions.put(formData, formData.id, objectUser);
        handleCloseDialog();
        cancel();
      }
    });
  };

  console.log(state.formData);

  return (
    <CustomizedDialogs
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        {loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <ValidatorForm
            id="myform"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Grid container justify="center">
              <Grid
                container
                justify="center"
                item
                xs={width === "lg" ? 8 : 12}
              >
                <Typography
                  variant="subtitle1"
                  className={classes.header}
                  gutterBottom
                >
                  Please input your identity as required below:
                </Typography>
                <Grid container item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className={classes.section}
                    gutterBottom
                  >
                    Personal Information
                  </Typography>
                </Grid>
                <Grid container item xs={11} spacing={1}>
                  <Grid item xs={12}>
                    <TextValidator
                      id="name"
                      label="Name"
                      name="name"
                      validators={["required"]}
                      className={classes.textField}
                      errorMessages={["Name is required"]}
                      margin="normal"
                      value={state.formData.name}
                      onChange={(e) => handleChange(e)}
                      autoFocus
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        id="birthdate"
                        name="birthdate"
                        format="dd/MM/yyyy"
                        input
                        label="Birthdate"
                        views={["year", "month", "date"]}
                        className={classes.textField}
                        value={state.formData.birthdate}
                        onChange={handleDateChange}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12}>
                    <SelectValidator
                      id="gender"
                      name="gender"
                      label="Gender"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.gender}
                      onChange={handleChange}
                    >
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                    </SelectValidator>
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="phone"
                      label="Phone"
                      name="phone"
                      margin="normal"
                      type="number"
                      value={state.formData.phone}
                      className={classes.textField}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextValidator
                      id="address"
                      label="Address"
                      name="address"
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.address}
                      onChange={(e) => handleChange(e)}
                    />
                  </Grid>
                </Grid>
                <Grid container item xs={12}>
                  <Typography
                    variant="subtitle1"
                    className={classes.section}
                    gutterBottom
                  >
                    Account Credential
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={11}
                  spacing={1}
                  style={{ paddingBottom: 30 }}
                >
                  {user?.type === "staff" && user?.operational?.level === 2 && (
                    <InputSelectSearch
                      value={state.formData.roles}
                      options={roleState.data
                        .filter(
                          (row) =>
                            (row.type === "brand" ||
                              row.type === "mall" ||
                              row.type === "hotel" ||
                              row.type === "residential") &&
                            row.is_admin
                        )
                        .map((row) => ({
                          value: row.id,
                          name: row.name,
                        }))}
                      onChange={(value) =>
                        handleChangeRole({
                          target: { name: "roles", value: value },
                        })
                      }
                      search
                      closeOnSelect={true}
                      validators={["required"]}
                      errorMessages={["Role is required"]}
                      placeholder="Search for role"
                    />
                  )}

                  {user?.type === "staff" && user?.operational?.level === 1 && (
                    <InputSelectSearch
                      value={state.formData.roles}
                      options={roleState.data
                        .filter((row) => row.type === user?.operational?.type)
                        .map((row) => ({
                          value: row.id,
                          name: row.name,
                        }))}
                      onChange={(value) =>
                        handleChangeRole({
                          target: { name: "roles", value: value },
                        })
                      }
                      search
                      closeOnSelect={true}
                      validators={["required"]}
                      errorMessages={["Role is required"]}
                      placeholder="Search for role"
                    />
                  )}

                  {user?.type === "staff" && user?.operational?.level === 3 && (
                    <InputSelectSearch
                      value={state.formData.roles}
                      options={roleState.data
                        .filter((row) => row.is_admin || row.type === "group")
                        .map((row) => ({
                          value: row.id,
                          name: row.name,
                        }))}
                      onChange={(value) =>
                        handleChangeRole({
                          target: { name: "roles", value: value },
                        })
                      }
                      search
                      closeOnSelect={true}
                      validators={["required"]}
                      errorMessages={["Role is required"]}
                      placeholder="Search for role"
                    />
                  )}

                  {user?.operational?.level === 2 &&
                    user?.type === "staff" &&
                    selectedRole?.type !== "brand" && (
                      <InputSelectSearch
                        value={state.formData.operational}
                        options={optionsProperty}
                        getOptions={(query) => asyncGetOptionsProperty(query)}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "operational", value: value },
                          })
                        }
                        search
                        closeOnSelect={true}
                        validators={["required"]}
                        errorMessages={["Property is required"]}
                        placeholder="Search for property"
                      />
                    )}

                  {user?.operational?.level === 3 &&
                    user?.type === "staff" &&
                    selectedRole?.type !== "group" && (
                      <InputSelectSearch
                        value={state.formData.operational}
                        options={optionsProperty}
                        getOptions={(query) => asyncGetOptionsProperty(query)}
                        onChange={(value) =>
                          handleChange({
                            target: { name: "operational", value: value },
                          })
                        }
                        search
                        closeOnSelect={true}
                        validators={["required"]}
                        errorMessages={["Property is required"]}
                        placeholder="Search for property"
                      />
                    )}

                  <TextValidator
                    id="email"
                    label="email"
                    name="email"
                    className={classes.textField}
                    inputProps={{ maxLength: 51 }}
                    validators={["required", "isEmail", "maxStringLength:50"]}
                    errorMessages={[
                      "Email is required",
                      "Email is not valid",
                      "maximum character is 50",
                    ]}
                    margin="normal"
                    autoComplete="email"
                    readOnly
                    value={state.formData.email}
                    onChange={handleChange}
                  />
                  {!data && (
                    <TextValidator
                      id="password"
                      label="Password"
                      name="password"
                      readOnly
                      className={classes.textField}
                      margin="normal"
                      value={state.formData.password}
                      autoComplete="new-password"
                      inputProps={{ maxLength: 51 }}
                      validators={["required", "maxStringLength:50"]}
                      errorMessages={[
                        "Password is required",
                        "maximum character is 50",
                      ]}
                      type="password"
                      onChange={handleChange}
                    />
                  )}
                  {!data && (
                    <TextValidator
                      label="Repeat password"
                      onChange={handleChange}
                      className={classes.textField}
                      name="repeatPassword"
                      type="password"
                      margin="normal"
                      validators={["isPasswordMatch", "required"]}
                      errorMessages={[
                        "password mismatch",
                        "this field is required",
                      ]}
                      value={state.formData.repeatPassword}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </ValidatorForm>
        )}
      </DialogContent>
      {!loading && (
        <DialogActions>
          <Button
            onClick={() => {
              handleCloseDialog();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            form="myform"
            variant="contained"
            style={{ marginRight: 30 }}
            color="primary"
          >
            Submit
          </Button>
        </DialogActions>
      )}
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};

export function submitFormStaff(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
